import React, { useState, useEffect, useRef } from "react";

// Lodash
import { get, isEmpty, map, isEqual, sortBy } from "lodash";

// PropTypes
import PropTypes from "prop-types";

// Redux
import { tagChat } from "@Actions/chats";
import { displayNotification } from "@Actions/notifications";
import { connect } from "react-redux";

// Components
import IkTable from "@Components/IkTable";
import IKModal from "@Components/IkModal";

// Utils
import dataHandler from "@Utils/dataHandler";
import Api from "@Api";

// Modals
import NotaModal from "../NotaModal";

// Styles
import styles from "./styles.module.css";

const Tags = ({ onClose, dispatch, currentChat, onSuccesTags = () => {}, onTagClose = false, labelTip, search }) => {
	const [, setTags] = useState([]);
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState([]);
	const [checkAlllData, setCheckAllData] = useState([]);
	const [selected, setSelected] = useState([]);
	const [initialTagIds, setInitialTagIds] = useState([]);
	const [openNotaModal, setOpenNotaModal] = useState(false);
	const [tagsNeedingNota, setTagsNeedingNota] = useState([]);
	const [pendingNotas, setPendingNotas] = useState([]);
	const pendingNotasRef = useRef([]);
	pendingNotasRef.current = pendingNotas;
	let defaultParams = {
		page: 1,
		orderKey: "id",
		orderDir: "desc",
		rows: 15,
	};

	if (currentChat.groupId) {
		defaultParams = { ...defaultParams };
	}
	if (!isEmpty(search)) {
		defaultParams = { ...defaultParams, all: search };
	}

	useEffect(() => {
		(async () => {
			const tagsPromese = await dataHandler({
				dispatch,
				url: "tags/grouped",
				params: { page: 1, orderKey: "id", orderDir: "desc", rows: 15 },
			});
			setFilteredCount(tagsPromese.count);
			setFilteredItems(tagsPromese.items);
			const initialTags = get(currentChat, "tags", []);
			setCheckAllData(initialTags);
			setInitialTagIds(map(initialTags, "id"));
		})();
	}, []);

	const handlerMultiple = (selectedItems) => {
		const newIds = map(selectedItems, "id");

		setSelected(selectedItems);
		setCheckAllData(selectedItems);

		const needingNota = selectedItems.filter((t) => {
			return (
				get(t, "category.settings.aplica_nota", false) &&
				!pendingNotasRef.current.some((n) => {
					return n.tagId === t.id;
				})
			);
		});
		if (!isEmpty(needingNota)) {
			setTagsNeedingNota((prev) => {
				const existingIds = map(prev, "id");
				const toAdd = needingNota.filter((t) => {
					return !existingIds.includes(t.id);
				});
				return [...prev, ...toAdd];
			});
			setOpenNotaModal(true);
		}

		setPendingNotas((prev) => {
			return prev.filter((n) => {
				return newIds.includes(n.tagId);
			});
		});

		setTagsNeedingNota((prev) => {
			return prev.filter((t) => {
				return (
					newIds.includes(t.id) &&
					!pendingNotasRef.current.some((n) => {
						return n.tagId === t.id;
					})
				);
			});
		});
	};
	const handlerData = async (params, printable, findAll, isCheck = false, options = {}) => {
		// Por defecto withLoading es true, pero CardTable puede pasarlo como false
		const { withLoading = true } = options;
		const data = await dataHandler({ dispatch, url: "tags/grouped", params, withLoading });
		if (!isCheck && !printable) {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
		}

		if (isCheck) {
			if (findAll) {
				setCheckAllData(data.items);
			} else {
				setCheckAllData([]);
			}
		}
	};

	const onSucces = () => {
		if (onTagClose) {
			onSuccesTags();
			onClose();
		}
	};

	const handlerSaved = async () => {
		const selectedTags = !isEmpty(selected) ? selected : checkAlllData;
		if (isEmpty(selectedTags)) return;

		const tagsId = map(selectedTags, (tag) => {
			return get(tag, "id", null);
		});

		const chatId = get(currentChat, "id", null);

		const notas = pendingNotasRef.current;

		for (const item of notas) {
			if (item.nota) {
				try {
					await Api.post("chattags", {
						chatId,
						tagId: item.tagId,
						nota: item.nota,
					});
				} catch (err) {
					dispatch(displayNotification({ text: "Error al guardar la nota", isError: true, isTemporary: true }));
				}
			}
		}

		dispatch(tagChat(chatId, tagsId, onSucces));
		setPendingNotas([]);
		onClose();
	};

	const handleNotaConfirm = async (notas) => {
		const newNotas = notas.filter((n) => {
			return n.nota;
		});
		if (!isEmpty(newNotas)) {
			setPendingNotas((prev) => {
				const filtered = prev.filter((p) => {
					return !newNotas.some((n) => {
						return n.tagId === p.tagId;
					});
				});
				return [...filtered, ...newNotas];
			});
		}

		const confirmedIds = map(notas, "tagId");
		setOpenNotaModal(false);
		setTagsNeedingNota((prev) => {
			return prev.filter((t) => {
				return !confirmedIds.includes(t.id);
			});
		});
	};

	const handleNotaClose = () => {
		setOpenNotaModal(false);
		setTagsNeedingNota([]);
	};

	const handleButtom = (name, item) => {
		switch (name) {
			case "onClick": {
				setTags(item);
				const isSelected = selected.some((s) => {
					return s.id === item.id;
				});

				if (isSelected) {
					const newSelected = selected.filter((s) => {
						return s.id !== item.id;
					});
					setSelected(newSelected);
					setCheckAllData(newSelected);
					setPendingNotas((prev) => {
						return prev.filter((n) => {
							return n.tagId !== item.id;
						});
					});
					setTagsNeedingNota((prev) => {
						return prev.filter((t) => {
							return t.id !== item.id;
						});
					});
				} else {
					const newSelected = [...selected, item];
					setSelected(newSelected);
					setCheckAllData(newSelected);

					const needsNota = get(item, "category.settings.aplica_nota", false);
					const alreadyHasNota = pendingNotasRef.current.some((n) => {
						return n.tagId === item.id;
					});
					if (needsNota && !alreadyHasNota) {
						setTagsNeedingNota((prev) => {
							if (
								prev.some((t) => {
									return t.id === item.id;
								})
							)
								return prev;
							return [...prev, item];
						});
						setOpenNotaModal(true);
					}
				}
				break;
			}
			default:
				break;
		}
	};

	const hasChanges = () => {
		if (isEmpty(selected)) return false;
		const selectedIds = map(selected, "id");
		return !isEqual(sortBy(selectedIds), sortBy(initialTagIds));
	};

	return (
		<>
			<IKModal
				title="Etiquetas"
				onClose={onClose}
				onSuccess={handlerSaved}
				size="tiny"
				saveDisabled={!hasChanges()}
				fullHeight
				saveLabel={labelTip || "Guardar"}>
				<div className={styles.grid}>
					<IkTable
						data={filteredItems}
						columns={[
							{
								key: "id",
								dataPosition: "center",
								width: 1,
								multiple: true,
							},
							{
								label: "ID",
								key: "id",
								format: "string",
								dataPosition: "left",
								width: 1,
							},
							{
								label: "Nombre",
								key: "name",
								format: "string",
								headerPosition: "left",
								width: 15,
							},
						]}
						handlerTable={handleButtom}
						mobileCardView
						cardLine1={[
							{ key: "id", label: "ID" },
							{ key: "name", label: "" },
						]}
						totalRows={filteredCount}
						defaultParams={defaultParams}
						dataHandler={handlerData}
						// mergeConfig={{ groupKey: "name", itemsKey: "items", idKey: "id" }}
						searcher={{
							searchString: search,
							searchable: true,
							searchPosition: "flex-start",
							searchDisabled: false,
							filterButton: false,
						}}
						handlerMultiple={handlerMultiple}
						checkAllData={checkAlllData}
						headerDetail={{ headerTitle: "groupName", dataDetail: "tasks" }}
					/>
				</div>
			</IKModal>
			{openNotaModal && !isEmpty(tagsNeedingNota) && (
				<NotaModal tags={tagsNeedingNota} onClose={handleNotaClose} onConfirm={handleNotaConfirm} />
			)}
		</>
	);
};

Tags.propTypes = {
	onClose: PropTypes.func,
	dispatch: PropTypes.func,
	currentChat: PropTypes.object,
	onSuccesTags: PropTypes.func,
	onTagClose: PropTypes.bool,
	labelTip: PropTypes.string,
	search: PropTypes.string,
};

export default connect()(Tags);
